var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apple-pay-button',{attrs:{"id":"apple-pay-button","buttonstyle":"black","type":"buy"},on:{"click":_vm.startApplePaySession}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }